module.exports = __webpack_public_path__ + "static/media/IMG_4198.56923786.JPG";